import { SseEventDtoEvent } from '@/api/model'
import { toast } from '@/shared/toaster'
import { Listeners } from 'src/api/sse'
import i18n, { Resources } from 'i18next'

type ToastKeys = keyof Resources['app']['sse_toast']
export type ToastKey = `app:sse_toast.${ToastKeys & string}`
const t = (key: ToastKey) => i18n.t(key)

const dreamUnfrozenNotification: Listeners['dream.unfrozen'][number] = () => {
  toast.success(t('app:sse_toast.dream_unfrozen'))
}

const dreamGoalReachedNotification: Listeners['dream.goal_reached'][number] =
  () => {
    toast.success(t('app:sse_toast.dream_goal_reached'))
  }

const dreamFrozenNotification: Listeners['dream.frozen'][number] = () => {
  toast.success(t('app:sse_toast.dream_frozen'))
}

const donationReceivedNotification: Listeners['donation.received'][number] =
  () => {
    toast.success(t('app:sse_toast.donation_received'))
  }

const dreamDeletedNotification: Listeners['dream.deleted'][number] = () => {
  toast.success(t('app:sse_toast.dream_deleted'))
}

const referralNewUserNotification: Listeners['referral.new_user'][number] =
  () => {
    toast.success(t('app:sse_toast.referral_new_user'))
  }

const dreamRejectedNotification: Listeners['dream.rejected'][number] = () => {
  toast.success(t('app:sse_toast.dream_rejected'))
}

const dreamApprovedNotification: Listeners['dream.approved'][number] = () => {
  toast.success(t('app:sse_toast.dream_approved'))
}

const withdrawalRequestedNotification: Listeners['withdrawal.requested'][number] =
  () => {
    toast.success(t('app:sse_toast.withdrawal_requested'))
  }

const withdrawalApprovedNotification: Listeners['withdrawal.approved'][number] =
  () => {
    toast.success(t('app:sse_toast.withdrawal_approved'))
  }

const withdrawalRejectedNotification: Listeners['withdrawal.rejected'][number] =
  () => {
    toast.success(t('app:sse_toast.withdrawal_rejected'))
  }

const withdrawalCompletedNotification: Listeners['withdrawal.completed'][number] =
  () => {
    toast.success(t('app:sse_toast.withdrawal_completed'))
  }

const withdrawalFailedNotification: Listeners['withdrawal.failed'][number] =
  () => {
    toast.success(t('app:sse_toast.withdrawal_failed'))
  }

const donationConfirmedNotification: Listeners['donation.confirmed'][number] =
  () => {
    toast.success(t('app:sse_toast.donation_confirmed'))
  }

export const userNotifications: {
  [K in keyof Listeners]?: Listeners[K][number]
} = {
  [SseEventDtoEvent.dreamunfrozen]: dreamUnfrozenNotification,
  [SseEventDtoEvent.dreamgoal_reached]: dreamGoalReachedNotification,
  [SseEventDtoEvent.dreamfrozen]: dreamFrozenNotification,
  [SseEventDtoEvent.donationreceived]: donationReceivedNotification,
  [SseEventDtoEvent.dreamdeleted]: dreamDeletedNotification,
  [SseEventDtoEvent.referralnew_user]: referralNewUserNotification,
  [SseEventDtoEvent.dreamrejected]: dreamRejectedNotification,
  [SseEventDtoEvent.dreamapproved]: dreamApprovedNotification,
  [SseEventDtoEvent.withdrawalrequested]: withdrawalRequestedNotification,
  [SseEventDtoEvent.withdrawalapproved]: withdrawalApprovedNotification,
  [SseEventDtoEvent.withdrawalrejected]: withdrawalRejectedNotification,
  [SseEventDtoEvent.withdrawalcompleted]: withdrawalCompletedNotification,
  [SseEventDtoEvent.withdrawalfailed]: withdrawalFailedNotification,
  [SseEventDtoEvent.donationconfirmed]: donationConfirmedNotification,
} as const
